/*
    Handle style customizations based on lender settings
*/
import { useMemo } from 'react';

import { CompanyFragment } from '@willow/graphql-iso/src/portal';

import { hexToRgbA } from './utils';

// Default logo heights (matches Banner.scss defaults)
const DEFAULT_LOGO_HEIGHT = '20px'; // mobile
const DEFAULT_LOGO_HEIGHT_MD = '26px'; // desktop

// Company-specific logo height overrides
// To add a new override, add the company ID and desired heights here
const LOGO_HEIGHT_OVERRIDES: Record<string, { mobile: string; desktop: string }> = {
  '514c3422-5918-4f15-b914-269d1ef5bc31': { mobile: '30px', desktop: '40px' }, // EDUCATED_MORTGAGE_SERVICES
};

export const useStyleCustomization = (company: CompanyFragment | undefined) => {
  const primaryColor = useMemo<string | undefined>(() => company?.portalSettings?.primaryColor || undefined, [company]);
  const secondaryColor = useMemo<string | undefined>(
    () => (primaryColor ? hexToRgbA(primaryColor) : undefined),
    [primaryColor],
  );

  const logoHeightMobile = company?.id
    ? LOGO_HEIGHT_OVERRIDES[company.id]?.mobile ?? DEFAULT_LOGO_HEIGHT
    : DEFAULT_LOGO_HEIGHT;
  const logoHeightDesktop = company?.id
    ? LOGO_HEIGHT_OVERRIDES[company.id]?.desktop ?? DEFAULT_LOGO_HEIGHT_MD
    : DEFAULT_LOGO_HEIGHT_MD;

  // Default primary = $blue1
  // Default secondary = $blue0
  return {
    primaryColor: primaryColor || '#0070ae',
    secondaryColor: secondaryColor || '#f2f8fb',
    logoHeightMobile,
    logoHeightDesktop,
  };
};
